var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDartIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dart-mission-goal-success-svgrepo-com 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M42.3281 7.31039C42.1875 6.74789 41.625 6.46664 41.0625 6.46664H36.8438V2.24789C36.8438 1.68539 36.5625 1.12289 36 0.98226C35.4375 0.70101 34.875 0.841635 34.4531 1.26351L28.8281 6.88851C28.5469 7.16976 28.4063 7.45101 28.4063 7.87289V12.9354L20.3906 20.951C19.8281 21.5135 19.8281 22.3573 20.3906 22.9198C20.6719 23.201 21.0937 23.3416 21.375 23.3416C21.6562 23.3416 22.0781 23.201 22.3594 22.9198L30.375 14.9041H35.4375C35.8594 14.9041 36.1406 14.7635 36.4219 14.4823L42.0469 8.85726C42.4688 8.43539 42.6094 7.87289 42.3281 7.31039Z",
    fill: "url(#paint0_linear_115_7107)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M24.3281 24.8906C23.625 25.7344 22.5 26.1562 21.375 26.1562C20.25 26.1562 19.125 25.7344 18.4219 24.8906C16.7344 23.2031 16.7344 20.5312 18.4219 18.9844L22.3594 15.0469C22.0781 14.9063 21.6562 14.9062 21.375 14.9062C17.4375 14.9062 14.3438 18 14.3438 21.9375C14.3438 25.875 17.4375 28.9688 21.375 28.9688C25.3125 28.9688 28.4062 25.875 28.4062 21.9375C28.4062 21.6562 28.4062 21.2344 28.2656 20.9531L24.3281 24.8906Z",
    fill: "url(#paint1_linear_115_7107)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M38.3906 16.4531C37.6875 17.2969 36.5625 17.7188 35.4375 17.7188H31.5L30.5156 18.7031C30.9375 19.6875 31.0781 20.8125 31.0781 21.9375C31.0781 27.4219 26.7188 31.7812 21.2344 31.7812C15.75 31.7812 11.3906 27.4219 11.3906 21.9375C11.3906 16.4531 15.75 12.0938 21.2344 12.0938C22.3594 12.0938 23.4844 12.375 24.4688 12.6562L25.5938 11.8125V7.875C25.5938 6.75 26.0156 5.625 26.8594 4.92188L28.2656 3.51563C26.0156 2.67188 23.7656 2.25 21.375 2.25C10.5469 2.25 1.6875 11.1094 1.6875 21.9375C1.6875 32.7656 10.5469 41.625 21.375 41.625C32.2031 41.625 41.0625 32.7656 41.0625 21.9375C41.0625 19.5469 40.6406 17.2969 39.7969 15.0469L38.3906 16.4531Z",
    fill: "url(#paint2_linear_115_7107)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_115_7107",
    x1: 31.2216,
    y1: 0.835938,
    x2: 51.75,
    y2: 19.126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.424375,
    stopColor: "#FF646C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_115_7107",
    x1: 12.375,
    y1: 18,
    x2: 34.3125,
    y2: 27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF636A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_115_7107",
    x1: 3.9375,
    y1: 1.6875,
    x2: 40.5,
    y2: 35.4375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7986"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6067"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDartIcon);
export default __webpack_public_path__ + "static/media/DartIcon.08646e13f169c62c3034265e9b7ceb69.svg";
export { ForwardRef as ReactComponent };